export type Clip =
    | "border-box"
    | "padding-box"
    | "content-box"
    | "initial"
    | "inherit";

export function isClip(value: string): value is Clip {
    return [
        "border-box",
        "padding-box",
        "content-box",
        "initial",
        "inherit"
    ].includes(value);
}
